import React, { useState, useEffect } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import Pagination from "@mui/material/Pagination";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import AddInvestorModal from "./AddInvestorModal";
import sourceUrl from "../../api/Source.api";

const Investors = ({ token }) => {
  const [investors, setInvestors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalInvestorsCount, setTotalInvestorsCount] = useState(0);
  const [searchEmail, setSearchEmail] = useState("");
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const fetchInvestors = async () => {
      try {
        setLoading(true);
        const res = await axios.get(`${sourceUrl}/admin/investors`, {
          params: { page: currentPage, pagesize: 10, email: searchEmail },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (res.data && res.data.data) {
          setInvestors(res.data.data.data);
          setTotalPages(Math.ceil(res.data.data.totalRows / 10));
          setTotalInvestorsCount(res.data.data.totalRows);
        }
      } catch (error) {
        console.error(error);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchInvestors();
  }, [currentPage, searchEmail, token]);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const handleSearchChange = (event) => {
    setSearchEmail(event.target.value);
  };

  const handleAddInvestor = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleSaveInvestor = async (investorData) => {
    try {
      const response = await axios.post(
        `${sourceUrl}/admin/investors`, // Updated endpoint
        investorData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );

      if (response.data) {
        setShowModal(false);
        // Refetch investors to update the list
        const res = await axios.get(`${sourceUrl}/admin/investors`, {
          params: { page: currentPage, pagesize: 10 },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setInvestors(res.data.data.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const theme = createTheme({
    typography: {
      fontFamily: "Inter",
    },
    components: {
      MuiPagination: {
        styleOverrides: {
          root: {
            "& .MuiPaginationItem-root": {
              color: "#ffffff",
              borderRadius: "20px",
              "&:hover": {
                backgroundColor: "rgba(179, 168, 183, 0.26)",
              },
              fontSize: "14px",
            },
            "& .MuiPaginationItem-page.Mui-selected": {
              backgroundColor: "#CAC4D0",
              color: "black",
              "&:hover": {
                backgroundColor: "#CAC4D0",
              },
            },
            "& .MuiPaginationItem-ellipsis": {
              color: "#ffffff",
            },
            "& .MuiPaginationItem-previousNext": {
              color: "#ffffff",
              borderRadius: "20px",
            },
          },
        },
      },
    },
  });

  return (
    <div className="card">
      <div className="card-body">
        <div className="d-flex justify-content-between mb-3">
          <h5 className="card-title">Total Investors Count:</h5>
          <h5 className="card-title text-primary">{totalInvestorsCount}</h5>
        </div>
        <div className="mb-3">
          <input
            type="text"
            className="form-control"
            placeholder="Search by email"
            value={searchEmail}
            onChange={handleSearchChange}
          />
        </div>
        <button className="btn btn-primary mb-3" onClick={handleAddInvestor}>
          Add New Investor
        </button>
        <div className="overflow-auto" style={{ maxHeight: "300px" }}>
          {loading ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ height: "100%" }}
            >
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only"></span>
              </div>
            </div>
          ) : (
            <ul className="list-group">
              {investors.map((investor, index) => (
                <li key={index} className="list-group-item">
                  <div>
                    <strong>Email:</strong> {investor.email}
                  </div>
                  <div>
                    <strong>Name:</strong> {investor.firstname} {investor.lastname}
                  </div>
                  <div>
                    <strong>Company:</strong> {investor.companies}
                  </div>
                  <div>
                    <strong>Location:</strong> {investor.location}
                  </div>
                  <div>
                    <strong>Investments:</strong> {investor.number_of_investments}
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
        <div className="d-flex justify-content-center mt-3">
          <ThemeProvider theme={theme}>
            <Pagination
              count={totalPages}
              page={currentPage}
              siblingCount={1}
              boundaryCount={1}
              onChange={handlePageChange}
              shape="rounded"
              size="large"
            />
          </ThemeProvider>
        </div>
      </div>
      <AddInvestorModal
        show={showModal}
        handleClose={handleCloseModal}
        handleSave={handleSaveInvestor}
      />
    </div>
  );
};

export default Investors;